//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi, bytesToSize} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DJAreaSideMenu from './sidemenu';
import Waveform from 'react-audio-waveform';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';

import './css/weekly.css';

export default class AdminWeekly extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			hyper: [],
			hyper_select: {},
			evolution: [],
			evolution_select: {},
			sets: [],
		};
		this.selectAllBoxes = this.selectAllBoxes.bind(this);
		this.prepare = this.prepare.bind(this);
		this.downloadFile = this.downloadFile.bind(this);
		this.deleteFile = this.deleteFile.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Weekly Sets - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		const x = await postApi('/api/v2/admin/weekly', params);
		this.setState({status: true, hyper: x.data.hyper,
			/*hyper_select: x.data.hyper.reduce((options, option) => ({...options,[option.filename]: false}),{}),*/
			evolution: x.data.evolution,
			/*evolution_select: x.data.evolution.reduce((options, option) => ({...options,[option.filename]: false}),{}),*/
			sets: x.data.Sets,
		});

		//let OPTIONS = x.data.hyper;
		let hyper_select = {};
		for( let i in x.data.hyper ) {
			hyper_select[x.data.hyper[i].filename] = false;
		}
		let evolution_select = {};
		for( let i in x.data.hyper ) {
			evolution_select[x.data.hyper[i].filename] = false;
		}

		this.setState({hyper_select, evolution_select});

	
		/*this.setState({
			hyper_select: x.data.hyper.reduce(
				(options, option) => ({
					...options,
					[option.filename]: false
				})
			)
		});
		this.setState({
			evolution_select: x.data.evolution.reduce(
				(options, option) => ({
					...options,
					[option.filename]: false
				}),
			)
		});*/
	}

	componentWillUnmount() {
	}

	selectAllBoxes = (channel, isSelected) => {
    if( channel === 'hyper' ) Object.keys(this.state.hyper_select).forEach(checkbox => {
      // BONUS: Can you explain why we pass updater function to setState instead of an object?
      this.setState(prevState => ({
        hyper_select: {
          ...prevState.hyper_select,
          [checkbox]: isSelected
        }
      }));
    });

		if( channel === 'evolution' ) Object.keys(this.state.evolution_select).forEach(checkbox => {
      // BONUS: Can you explain why we pass updater function to setState instead of an object?
      this.setState(prevState => ({
        evolution_select: {
          ...prevState.evolution_select,
          [checkbox]: isSelected
        }
      }));
    });

  };

	selectAll = (channel) => this.selectAllBoxes(channel,true);
  deselectAll = (channel) => this.selectAllBoxes(channel,false);

	handleCheckboxChange = (changeEvent) => {
    const { name } = changeEvent.target;

    this.setState(prevState => ({
      hyper_select: {
        ...prevState.hyper_select,
        [name]: !prevState.hyper_select[name]
      }
    }));
		this.setState(prevState => ({
      evolution_select: {
        ...prevState.evolution_select,
        [name]: !prevState.evolution_select[name]
      }
    }));
  };


	async prepare(event) {
		event.preventDefault();
		let params = new URLSearchParams();

		let sets = [];
		Object.keys(this.state.hyper_select).filter(checkbox => this.state.hyper_select[checkbox]).forEach(checkbox => {
			for( let i in this.state.hyper ) {
				if(this.state.hyper[i].filename === checkbox) {
					sets.push({filename: checkbox, showname: this.state.hyper[i].showname, uid: this.state.hyper[i].id, avatar: this.state.hyper[i].avatar, username: this.state.hyper[i].title?this.state.hyper[i].title:this.state.hyper[i].username});
				}
			}
		});
		//params.append('hyper',JSON.stringify(hyper));

		//let evolution = [];
		Object.keys(this.state.evolution_select).filter(checkbox => this.state.evolution_select[checkbox]).forEach(checkbox => {
			for( let i in this.state.evolution ) {
				if(this.state.evolution[i].filename === checkbox) {
					sets.push({filename: checkbox, showname: this.state.evolution[i].showname, uid: this.state.evolution[i].id, avatar: this.state.evolution[i].avatar, username: this.state.evolution[i].title?this.state.evolution[i].title:this.state.evolution[i].username});
				}
			}
		});
		params.append('sets',JSON.stringify(sets));


		await putApi('/api/v2/admin/weekly', params);

		setTimeout(async ()=>{
			let params2 = new URLSearchParams();
			const x = await postApi('/api/v2/admin/weekly', params2);
			this.setState({sets: x.data.Sets});
		}, 10000);

	}
	
	downloadFile(file) {
		window.location.href="https://mix365.co.uk/uploads/weekly/"+file;
	}

	async deleteFile(file) {
		if( window.confirm("Are you sure you wish to delete this set?")) {
			let params = new URLSearchParams();
			params.append('set', file);
			const x = await deleteApi('/api/v2/admin/weekly', params);
			if( x.status === 200 ) {
				this.componentDidMount();
			}
		}
	}

	render() {
		const hyper = Object.keys(this.state.hyper).map((e,i) => {
			return (
				<Row key={i} className="py-1 gx-0">
					<Col>
						<input 
							type="checkbox"
							name={this.state.hyper[e].filename}
							id={`hyper[${this.state.hyper[e].filename}]`}

							checked={this.state.hyper_select[this.state.hyper[e].filename]}
							onChange={this.handleCheckboxChange}

						/>&nbsp;
						<Form.Label htmlFor={`hyper[${this.state.hyper[e].filename}]`} className="admin-weekly-pointer">{this.state.hyper[e].showname}</Form.Label>
					</Col>
					<Col xs={4}>
						<Form.Label htmlFor={`hyper[${this.state.hyper[e].filename}]`} className="admin-weekly-pointer">{this.state.hyper[e].filename}</Form.Label>
					</Col>
					<Col xs={10}>
						<Waveform
							barWidth={2}
							peaks={this.state.hyper[e].waveform.data}
							height={50}
							
							//progressColor={'#ff0000'}
							
							color="#3E5151"
							progressGradientColors={[[0, "#07E6A5"], [1, "#00A4FC"]]}
						/>
					</Col>
				</Row>
			)
		})
		const evolution = Object.keys(this.state.evolution).map((e,i) => {
			return (
				<Row key={i} className="py-1 gx-0">
					<Col>
						<input 
							type="checkbox"
							name={this.state.evolution[e].filename}
							id={`evolution[${this.state.evolution[e].filename}]`}

							checked={this.state.evolution_select[this.state.evolution[e].filename]}
							onChange={this.handleCheckboxChange}

						/>&nbsp;
						<Form.Label htmlFor={`evolution[${this.state.evolution[e].filename}]`} className="admin-weekly-pointer">{this.state.evolution[e].showname}</Form.Label>
					</Col>
					<Col xs={4}>
						<Form.Label htmlFor={`evolution[${this.state.evolution[e].filename}]`} className="admin-weekly-pointer">{this.state.evolution[e].filename}</Form.Label>
					</Col>
					<Col xs={10}>
						<Waveform
							barWidth={2}
							peaks={this.state.evolution[e].waveform.data}
							height={50}
							
							//progressColor={'#ff0000'}
							
							color="#3E5151"
							progressGradientColors={[[0, "#07E6A5"], [1, "#00A4FC"]]}
						/>
					</Col>
				</Row>
			)
		})
		const sets = 
      Object.keys(this.state.sets).map((e,i) => {
        return (
					<Row key={i} className="py-1 gx-0">
						<Col><a href={`https://mix365.co.uk/uploads/weekly/${this.state.sets[e].filename}`}>{this.state.sets[e].filename}</a></Col>
						<Col>{bytesToSize(this.state.sets[e].size)}</Col>
						<Col>
							<ButtonGroup size="sm">
								<Button onClick={()=>this.downloadFile(this.state.sets[e].filename)}>Download</Button>
								<Button onClick={()=>this.deleteFile(this.state.sets[e].filename)}>Delete</Button>
							</ButtonGroup>
						</Col>
					</Row>
        )
      })
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				{this.state.status &&
					<Col>
						<Row>
							<Col xs={12}>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Download Weekly sets</h3>
									</div>
									<div className="card-body">
										<Form onSubmit={this.prepare}>
											<h3>Hyper Sets:</h3><br />
											<ButtonGroup size="sm">
												<Button onClick={()=>this.deselectAll('hyper')}>
													Select None
												</Button>
												<Button onClick={()=>this.selectAll('hyper')}>
													Select All
												</Button>
											</ButtonGroup><br />
											<Row className="gx-0">
												{hyper}
											</Row>
										

											<br /><h3>Evolution Sets:</h3><br />
											<ButtonGroup size="sm">
												<Button onClick={()=>this.deselectAll('evolution')}>
													Select None
												</Button>
												<Button onClick={()=>this.selectAll('evolution')}>
													Select All
												</Button>
											</ButtonGroup><br />
											<Row className="gx-0">
												{evolution}
											</Row><br /><br />

											<h3>* Caution</h3>
											PLEASE ONLY PREPARE FULL LIST WHILST STATION IS QUIET<br /><br />

											<h3>Important Notes:</h3>
											You will need Winrar or alternative package that can open tar files <a href="https://www.win-rar.com/download.html?&L=0" target="blank">Download WinRar</a><br />
											Full list will take about 2 to 3 minutes to prepare and be ready for download<br />
											
											Please delete set after your download has completed<br /><br />

											<ButtonGroup size="sm">
												<Button onClick={this.prepare}>Prepare and Download</Button>
												<Button onClick={()=>this.componentDidMount()}>Reload List</Button>
											</ButtonGroup>
											
										</Form>
									</div>
								</div>
							</Col>
							<Col xs={12}>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Download Weekly sets</h3>
									</div>
									<div className="card-body">

										{sets}

									</div>
								</div>
							</Col>
						</Row>
					</Col>
				}
			</Row>
		);
	}
}
